import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { callApi, fetchApiDataIfNeeded } from '../../../actions/api'
import { apiResourceEndpoint, buildRoutePath, routes } from '../../../constants/routes'
import { createSelector } from '@reduxjs/toolkit'

import { PaginationWrapper } from 'shs-pagination'
import moment from 'moment'

const selectLeads = state => state.leads
const selectPaginator = state => state.paginator.leads

const makeLeads = createSelector(
    [selectLeads, selectPaginator],
    (leads, paginator) => {
        if (!paginator) {
            return leads
        }
        return leads.filter(field => paginator.itemIds.indexOf(field.id) !== -1)
            .sort((a, b) => {
                if (paginator.itemIds.indexOf(a.id) > paginator.itemIds.indexOf(b.id)) {
                    return 1
                }
                return -1
            })
    }
)

const mapStateToProps = (state) => {
    return {
        leads: makeLeads(state),
        paginator: selectPaginator(state),
        user: state.user
    }
}

const ListLeads = ({ dispatch, leads, paginator, user }) => {
    const [onlyAgent, setOnlyAgent] = useState(false)
    const agentId = user?._computed.agentId || null

    useEffect(() => {
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('leads', 'LIST'), { filter: [`agent_id||IS_NULL`, `agent_id|${agentId}`], filterMethod: 'OR' }))
    }, [dispatch])

    useEffect(() => {
        let searchParams = {
            page: 1,
            perpage: paginator?.perPage || 50,
            filter: onlyAgent ? [`agent_id|${agentId}`] : [`agent_id||IS_NULL`, `agent_id|${agentId}`],
            filterMethod: onlyAgent ? 'AND' : 'OR'
        }
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('leads', 'LIST'), searchParams))
    }, [onlyAgent])

    const handlePaginationUpdate = (paginationParams) => {
        paginationParams.filter = onlyAgent ? [`agent_id|${agentId}`] : [`agent_id||IS_NULL`, `agent_id|${agentId}`]
        paginationParams.filterMethod = onlyAgent ? 'AND' : 'OR'
        dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('leads', 'LIST'), paginationParams))
    }

    const renderDateInfo = (departureDate, returnDate, tripLength, weddingDate) => {
        let departureString = ''
        if (departureDate) {
            departureString = moment(departureDate).format('MMMM D, YYYY')
        }
        if (returnDate) {
            departureString = departureString + ' to ' + moment(returnDate).format('MMM D, YYYY')
        }
        return (
            <div className="trip-dates">
                {departureString}
                {departureString !== '' && <br />}
                {tripLength} day{tripLength > 1 ? 's' : ''}
                {weddingDate && <><br />Wedding: {moment(weddingDate).format('MMM. D, Y')}</>}
            </div>
        )
    }

    const renderDestinations = (destinations, origin) => {
        let destinationString = ''
        if (destinations && destinations.length > 0) {
            // destinatoins is a string. it may have extra commas in it, and they could be ,, or , ,
            // so we need to clean it up
            destinationString = destinations
                .split(',')
                .map(dest => dest.trim())
                .filter(dest => dest.length > 0)
                .join(', ')
        } else {
            destinationString = 'No destinations'
        }
        return (
            <div className="destinations">
                {destinationString}<br />
                <span className="origin">Origin: {origin ? origin : 'N/A'}</span>
            </div>
        )
    }

    const handleLeadClaim = (leadId) => {
        dispatch(callApi(apiResourceEndpoint('leads', 'UPDATE', leadId, 'claim-lead')))
    }

    const renderActions = (lead) => {
        return (
            <div className="actions">
                {!lead.agentId
                    ? <span className="clickable" onClick={() => handleLeadClaim(lead.id)}>Claim Lead</span>
                    : <Link to={buildRoutePath(routes.leadsView, { leadId: lead.id })} className="action-btn">View Lead</Link>
                }
            </div>
        )
    }

    const renderAccountsList = () => {
        let allLeads = []
        leads.forEach(lead => {
            allLeads.push(
                <div key={lead.id} className="lead-item">
                    <div className="lead-meta">
                        #{lead.tripId}
                    </div>
                    <div className="lead-details">
                        <div className="trip-name">
                            <span className="title">{lead.tripName}</span><br />
                            {lead.organizerFirstName} {lead.organizerLastName}
                        </div>
                        {renderDateInfo(lead.departureDate, lead.returnDate, lead.tripLength, lead.weddingDate)}
                        {renderDestinations(lead.destinations, lead.origin)}
                        <div className="luna-clone">
                            {lead.isLunaTrip
                                ? <img src="/luna_logo_solo.png" alt="Luna Trip" width="40" /> : <>&nbsp;</>}
                        </div>
                        {renderActions(lead)}
                    </div>
                    <div className="footer-info">
                        Created {moment(lead.createdOn).fromNow()}
                    </div>
                </div>
            )
        })
        return <div className="leads-list">{allLeads}</div>
    }

    const renderLeads = () => {
        if (!paginator) {
            return null
        }
        return (
            <PaginationWrapper
                paginator={paginator}
                controls={{ search: { enabled: true, collapsed: true } }}
                callbackFX={handlePaginationUpdate}>
                <span className="clickable" onClick={() => setOnlyAgent(!onlyAgent)}>
                    { onlyAgent ? 'Show All Leads' : 'Show My Leads Only' }
                </span>
                <div className={'cards list'}>
                    {renderAccountsList()}
                </div>
            </PaginationWrapper>
        )
    }

    return (
        <>
            <h2>Leads</h2>
            {renderLeads()}
        </>
    )
}

export default connect(mapStateToProps)(ListLeads)
